import { get, ref, set } from "firebase/database";
import { useEffect, useState } from "react";
import { db } from "../Firebase";

const EditNews = () => {
  const [newsText, setNewsText] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCurrentNews();
  }, []);

  const fetchCurrentNews = async () => {
    try {
      const newsRef = ref(db, 'news/marqueeText');
      const snapshot = await get(newsRef);
      if (snapshot.exists()) {
        setNewsText(snapshot.val());
      }
    } catch (error) {
      console.error("Error fetching news:", error);
    }
  };

  const handleSave = async () => {
    if (!newsText.trim()) {
      alert("कृपया समाचार टेक्स्ट दर्ज करें");
      return;
    }

    setLoading(true);
    try {
      await set(ref(db, 'news/marqueeText'), newsText);
      alert("समाचार सफलतापूर्वक अपडेट हो गया!");
    } catch (error) {
      console.error("Error saving news:", error);
      alert("समाचार अपडेट करने में त्रुटि हुई");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-4" style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="card shadow-lg border-0">
            <div className="card-header" style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" }}>
              <h4 className="text-white mb-0 fw-bold">📰 Edit News Marquee</h4>
            </div>
            <div className="card-body p-4">
              <div className="mb-4">
                <label className="form-label fw-semibold text-dark">
                  📝 News Text (समाचार टेक्स्ट):
                </label>
                <textarea
                  className="form-control"
                  rows="6"
                  value={newsText}
                  onChange={(e) => setNewsText(e.target.value)}
                  placeholder="यहाँ समाचार टेक्स्ट लिखें जो मार्की में दिखाया जाएगा..."
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.5",
                    border: "2px solid #e2e8f0",
                    borderRadius: "8px"
                  }}
                />
                <div className="form-text text-muted">
                  💡 टिप: इमोजी और विशेष चिह्न का उपयोग करें। उदाहरण: ✨ 🌟 📞 🏠
                </div>
              </div>

              <div className="mb-4">
                <h6 className="fw-semibold text-dark mb-2">🔍 Preview:</h6>
                <div
                  style={{
                    background: "linear-gradient(to right, #E0F2F1, #FFFFFF, #E0F2F1)",
                    color: "#0D9488",
                    fontWeight: "600",
                    height: "40px",
                    lineHeight: "40px",
                    borderTop: "2px solid #0D9488",
                    borderBottom: "2px solid #0D9488",
                    letterSpacing: "0.5px",
                    padding: "0 20px",
                    borderRadius: "4px",
                    overflow: "hidden",
                    whiteSpace: "nowrap"
                  }}
                >
                  <marquee behavior="scroll" direction="left" scrollAmount="5">
                    {newsText || "समाचार टेक्स्ट यहाँ दिखाई देगा..."}
                  </marquee>
                </div>
              </div>

              <div className="d-flex gap-3">
                <button
                  className="btn btn-success px-4 fw-semibold"
                  onClick={handleSave}
                  disabled={loading}
                  style={{ minWidth: "120px" }}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Saving...
                    </>
                  ) : (
                    <>💾 Save Changes</>
                  )}
                </button>
                <button
                  className="btn btn-outline-secondary px-4"
                  onClick={() => setNewsText("")}
                >
                  🗑️ Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditNews;